import { dropdownCategory } from '../../../common/const'

export const fieldNames = {
  lease: {
    label: 'VEHICLE_COMMON_WITH-OR-WITHOUT-LEASE_LABEL',
    name: 'withLease',
    type: 'select',
    selectOptions: dropdownCategory.withLease,
    tabIndexes: [5]
  },
  usage: {
    label: 'VEHICLE_COMMON_USAGE_LABEL',
    name: 'usage',
    type: 'select',
    selectOptions: dropdownCategory.usage,
    tabIndexes: [24]
  },
  owner: {
    label: 'VEHICLE_COMMON_OWNER_LABEL',
    name: 'owner',
    type: 'text',
    maxLength: 255,
    tabIndexes: [4]
  },
  privateBusinessUse: {
    label: 'VEHICLE_COMMON_PRIVATE-USE-OR-BUSINESS-USE_LABEL',
    name: 'privateBusinessUse',
    type: 'select',
    selectOptions: dropdownCategory.privateBusinessUse,
    tabIndexes: [25]
  },

  voluntaryInsuranceType: {
    label: 'VEHICLE_COMMON_VOLUNTARY-INSURANCE-TYPE_LABEL',
    name: 'voluntaryInsuranceType',
    type: 'select',
    selectOptions: dropdownCategory.voluntaryInsuranceType,
    tabIndexes: [28]
  },
  automobileTax: {
    label: 'VEHICLE_COMMON_AUTOMOBILE-TAX_LABEL',
    name: 'automobileTax',
    type: 'number',
    tabIndexes: [11, 12]
  },
  weightTax: {
    label: 'VEHICLE_COMMON_WEIGHT-TAX_LABEL',
    name: 'weightTax',
    type: 'number',
    tabIndexes: [13, 14]
  },
  mileage: {
    label: 'VEHICLE_COMMON_MILEAGE_LABEL',
    name: 'mileage',
    type: 'number',
    tabIndexes: [17, 18]
  },
  leaseFee: {
    label: 'VEHICLE_COMMON_LEASE-FEE_LABEL',
    name: 'leaseFee',
    type: 'number',
    tabIndexes: [9, 10]
  },
  leaseEndDate: {
    label: 'VEHICLE_COMMON_LEASE-END-DATE_LABEL',
    name: 'leaseEndDate',
    type: 'date',
    tabIndexes: [7, 8]
  },
  inspectionExpireDate: {
    label: 'VEHICLE_COMMON_INSPECTION-EXPIRE-DATE_LABEL',
    name: 'inspectionExpireDate',
    type: 'date',
    tabIndexes: [15, 16]
  },
  mandatoryInsuranceEnd: {
    label: 'VEHICLE_COMMON_MANDATORY-INSURANCE-END-DATE_LABEL',
    name: 'mandatoryInsuranceEndDate',
    type: 'date',
    tabIndexes: [26, 27]
  },
  lastRegularMaintenance: {
    label: 'VEHICLE_COMMON_LAST-REGULAR-MAINTENANCE-DATE_LABEL',
    name: 'lastRegularMaintenanceDate',
    type: 'date',
    tabIndexes: [19, 20]
  },
  nextRegularMaintenance: {
    label: 'VEHICLE_COMMON_NEXT-REGULAR-MAINTENANCE-MONTH_LABEL',
    name: 'nextRegularMaintenanceMonth',
    type: 'month',
    tabIndexes: [22, 23]
  },
  voluntaryInsuranceEndDate: {
    label: 'VEHICLE_COMMON_VOLUNTARY-INSURANCE-END-DATE_LABEL',
    name: 'voluntaryInsuranceEndDate',
    type: 'date',
    tabIndexes: [29, 30]
  },
  specialVehiclePassExpire: {
    label: 'VEHICLE_COMMON_SPECIAL-VEHICLE-PASS-EXPIRE-DATE_LABEL',
    name: 'specialVehiclePassExpireDate',
    type: 'date',
    tabIndexes: [32, 33]
  },
  expensesIncludingLease: {
    label: 'VEHICLE_COMMON_EXPENSES-INCLUDE-LEASE_LABEL',
    name: 'expensesIncludingLease',
    type: 'select',
    selectOptions: dropdownCategory.expensesIncludingLease,
    tabIndexes: [6]
  },
  factoryInCharge: {
    label: 'VEHICLE_COMMON_ASSIGN-FACTORY_LABEL',
    name: 'factoryInCharge',
    type: 'text',
    maxLength: 255,
    tabIndexes: [31]
  },
  regularMaintenanceCycle: {
    label: 'VEHICLE_COMMON_LEGAL-INSPECTION-CYCLE_LABEL',
    name: 'regularMaintenanceCycle',
    type: 'select',
    selectOptions: dropdownCategory.regularMaintenanceCycle,
    tabIndexes: [21]
  }
}
